import { useEffect, useState } from "react";
import { Box, Skeleton, useMediaQuery } from "@mui/material";
import aboutheroimage from "../../assets/aboutheroimage.webp";
import CustomText, { textStyles } from "../../components/CustomText";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../components/BASE_URL";

const AboutSection = () => {
  const { t,i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const [loading, setLoading] = useState(true);
  const [aboutTitle, setAboutTitle] = useState("");
  const [aboutDesc, setAboutDesc] = useState("");

 useEffect(() => {
  setLoading(true);
  fetch(`${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=About`)
    .then((res) => res.json())
    .then((json) => {
      const aboutSection = json?.data?.find(
        (sec) => sec?.name?.trim().toLowerCase() === "about"
      );

      if (aboutSection?.items?.length) {
        // 🔹 Pick EN (idx 0) or ES (idx 1) based on i18n.language
        const selectedItem =
          i18n.language === "es"
            ? aboutSection.items.find((item) => item.idx === 1)
            : aboutSection.items.find((item) => item.idx === 0);

        setAboutTitle(selectedItem?.title || t("about_heading"));
        setAboutDesc(selectedItem?.description || t("about_subtext"));
      } else {
        setAboutTitle(t("about_heading"));
        setAboutDesc(t("about_subtext"));
      }
    })
    .catch(() => {
      setAboutTitle(t("about_heading"));
      setAboutDesc(t("about_subtext"));
    })
    .finally(() => setLoading(false));
}, [i18n.language, t]); // 🔑 re-run when language changes


  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${aboutheroimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
      }}
    >
      {/* Dark overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: "rgba(4, 25, 35, 0.65)",
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#fff",
          height: "100%",
          px: 2,
          py: isMobile ? 8 : 11,
        }}
      >
        {loading ? (
          <Skeleton
            variant="text"
            height={isMobile ? 50 : 70}
            width={isMobile ? "80%" : "50%"}
          />
        ) : (
          <CustomText
            style={{
              ...textStyles.h1,
              color: "#E7EBF0",
              marginBottom: isMobile ? "0rem" : "1rem",
              marginTop: isMobile ? "0rem" : "0rem",
              fontSize: isMobile ? "40px" : "50px",
            }}
          >
            {aboutTitle}
          </CustomText>
        )}

        {loading ? (
          <>
            <Skeleton variant="text" height={28} width="80%" sx={{ mt: 2 }} />
            <Skeleton variant="text" height={28} width="65%" />
          </>
        ) : (
          <CustomText
            style={{
              ...textStyles.body2,
              color: "#EFEFEF",
              maxWidth: "1175px",
              margin: "0 auto",
              marginTop: isMobile ? "20px" : "6px",
              fontSize: "24px",
            }}
          >
            {aboutDesc}
          </CustomText>
        )}
      </Box>
    </Box>
  );
};

export default AboutSection;



